module.exports = __webpack_public_path__ + "media/images/contest-disabled-label-right@2x-c3faf8a3bea0345aae0441589864e298.png";